// extracted by mini-css-extract-plugin
module.exports = {"header":"savedSearchList_header_3fspM8a","label":"savedSearchList_label_RuMkEfn","showMore":"savedSearchList_showMore_7a1IUeZ","actions":"savedSearchList_actions_2B6Gfyf"};